<template>
  <transition-group name="fade">
    <b-container key="container" class="py-4">
      <base-card :title="$t('appointmentsHistory')" key="appointment-history" class="mb-4">
        <appointment-history></appointment-history>
      </base-card>
      <base-card :title="$t('healthvariables')" key="health-variables" v-if="variables" class="mb-4">
        <clinic-history-variable v-for="(item, propName) in basicVariables" :rawData="item" :key="propName" :name="propName" :value="item.values" :date="item.dateTime" :variableName="item.variableName" class="mb-2" :editable="isEditable(propName) && !$route.query.h" :graphEnabled="hasGraph(propName)"></clinic-history-variable>
      </base-card>
      <base-card :title="$t('additional-health-variables')" v-if="variables" key="additional-health-variables" class="mb-4">
        <clinic-history-variable v-for="(item, propName) in additionalVariables" :rawData="item" :key="propName" :name="propName" :value="item.values" :date="item.dateTime" :variableName="item.variableName" class="mb-2" :editable="isEditable(propName) && !$route.query.h" :graphEnabled="hasGraph(propName)" slider></clinic-history-variable>
      </base-card>
      <base-card :title="$t('observations')" key="observations" class="mb-4">
        <base-textarea v-model="observations" :placeholder="$t('observations-ph')" :rows=3 :maxRows=9></base-textarea>
        <base-button @click="saveObservations" v-if="!$route.query.h">{{ $t('save') }}</base-button>
      </base-card>
      <history-chrondiseases-section key="chrondiseases" class="mb-4"></history-chrondiseases-section>
      <history-diseases-section key="diseases" class="mb-4"></history-diseases-section>
      <history-allergies-section key="allergies" class="mb-4"></history-allergies-section>
      <history-med-allergies-section key="medallergies" class="mb-4"></history-med-allergies-section>
      <history-medicines-section key="medicines" class="mb-4"></history-medicines-section>
      <history-vaccines-section key="vaccines" class="mb-4"></history-vaccines-section>
      <history-familybackgrounds-section key="familybackgrounds" class="mb-4"></history-familybackgrounds-section>
      <history-files-section key="files" class="mb-4"></history-files-section>
    </b-container>
  </transition-group>
</template>

<script>
import BaseCard from '@/components/base/ui/BaseCard.vue'
import es from '@/lang/es/clinic-history.json'
import en from '@/lang/en/clinic-history.json'
import ClinicHistoryVariable from '@/components/shared/ClinicHistoryVariable.vue'
import { omitBy } from 'lodash'
import { AGE, BODY_MASS_INDEX, HABITS, BLOOD_TYPE, MOOD_LEVEL } from '@/constants/clinicHistory'
import ClinicHistoryRepository from '@/repositories/ClinicHistoryRepository'
import AppointmentHistory from '@/components/shared/AppointmentHistory.vue'
import BaseTextarea from '@/components/base/forms/BaseTextarea'
import BaseButton from '@/components/base/buttons/BaseButton'
import HistoryAllergiesSection from './HistoryAllergiesSection.vue'
import HistoryMedAllergiesSection from './HistoryMedAllergiesSection.vue'
import HistoryDiseasesSection from './HistoryDiseasesSection.vue'
import HistoryChrondiseasesSection from './HistoryChrondiseasesSection.vue'
import HistoryVaccinesSection from './HistoryVaccinesSection.vue'
import HistoryMedicinesSection from './HistoryMedicinesSection.vue'
import HistoryFamilybackgroundsSection from './HistoryFamilybackgroundsSection.vue'
import HistoryFilesSection from './HistoryFilesSection.vue'
import { BContainer } from 'bootstrap-vue'

export default {
  name: 'clinic-history',
  components: {
    BaseCard,
    ClinicHistoryVariable,
    AppointmentHistory,
    BaseTextarea,
    BaseButton,
    HistoryAllergiesSection,
    HistoryMedAllergiesSection,
    HistoryDiseasesSection,
    HistoryChrondiseasesSection,
    HistoryVaccinesSection,
    HistoryMedicinesSection,
    HistoryFamilybackgroundsSection,
    HistoryFilesSection,
    BContainer
  },
  i18n: {
    messages: {
      es,
      en,
      mx: es
    }
  },
  props: {
    patientId: {
      type: String,
      required: false,
      default: null
    }
  },
  data () {
    return {
      variables: null,
      basicVariables: [],
      additionalVariables: [],
      activeVariables: [],
      nonEditableVariables: [AGE, BODY_MASS_INDEX],
      withoutGraphVariables: [AGE, HABITS, BLOOD_TYPE, BODY_MASS_INDEX, MOOD_LEVEL],
      observations: null
    }
  },
  created () {
    const token = this.$route.query.t || this.$store.getters['session/isLogged']
    if (!token) {
      this.$router.push('/unauthorized')
    } else {
      this.load()
    }
  },
  computed: {
    clinicHistoryRepository () {
      return ClinicHistoryRepository()
    }
  },
  methods: {
    load () {
      this.clinicHistoryRepository.getAllVariables().then((response) => {
        this.variables = response.data.data
        this.activeVariables = this.variables.activeVariables
        this.basicVariables = omitBy(this.variables.basicVariables, (item, key) => !this.activeVariables.includes(key))
        this.additionalVariables = this.variables.additionalVariables
      })
      this.clinicHistoryRepository.getObservations().then((response) => {
        this.observations = response.data.data
      })
    },
    isEditable (varName) {
      return !this.nonEditableVariables.includes(varName)
    },
    hasGraph (varName) {
      return !this.withoutGraphVariables.includes(varName)
    },
    saveObservations () {
      return this.clinicHistoryRepository.saveObservations(this.observations).then((response) => {
        if (response.data.data) {
        }
      })
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/shared/ClinicHistory.vue